import { SelfRegistrationConfig } from '@ui/shared/models';
import { ActionState, ActionStateCreator } from '@ui/legacy-lib';
import { createFeature, createReducer, on } from '@ngrx/store';
import {
  FetchSelfRegistrationConfig,
  FetchSelfRegistrationConfigFail,
  FetchSelfRegistrationConfigSuccess,
  ResetSelfRegistrationActionState,
  SelfRegisterOfflineContact,
  SelfRegisterOfflineContactFail,
  SelfRegisterOfflineContactSuccess
} from './offline-self-registration.action';

export interface OfflineSelfRegistrationState {
  selfRegistrationConfig: SelfRegistrationConfig;
  selfRegistrationConfigState: ActionState;
  selfRegisterOfflineContactActionState: ActionState;
}

export const initialState: OfflineSelfRegistrationState = {
  selfRegistrationConfig: null,
  selfRegistrationConfigState: ActionStateCreator.create(),
  selfRegisterOfflineContactActionState: ActionStateCreator.create()
};

export const offlineSelfRegistrationReducer = createReducer(
  initialState,
  on(FetchSelfRegistrationConfig, state => {
    return {
      ...state,
      selfRegistrationConfigState: ActionStateCreator.onStart()
    };
  }),
  on(FetchSelfRegistrationConfigSuccess, (state, action) => {
    return {
      ...state,
      selfRegistrationConfigState: ActionStateCreator.onSuccess(),
      selfRegistrationConfig: action.selfRegistrationConfig
    };
  }),
  on(FetchSelfRegistrationConfigFail, (state, action) => {
    return {
      ...state,
      selfRegistrationConfigState: ActionStateCreator.onError(action.error)
    };
  }),
  on(SelfRegisterOfflineContact, state => {
    return {
      ...state,
      selfRegisterOfflineContactActionState: ActionStateCreator.onStart()
    };
  }),
  on(SelfRegisterOfflineContactSuccess, state => {
    return {
      ...state,
      selfRegisterOfflineContactActionState: ActionStateCreator.onSuccess()
    };
  }),
  on(SelfRegisterOfflineContactFail, (state, action) => {
    return {
      ...state,
      selfRegisterOfflineContactActionState: ActionStateCreator.onError(
        action.error
      )
    };
  }),
  on(ResetSelfRegistrationActionState, state => {
    return {
      ...state,
      selfRegisterOfflineContactActionState: ActionStateCreator.create()
    };
  })
);

export const offlineSelfRegistrationFeature = createFeature({
  name: 'offline-self-registration',
  reducer: offlineSelfRegistrationReducer
});
